import { v4 as uuidv4 } from 'uuid';
function chillHop() {
	return [
		{
			name: 'Beaver Creek',
			cover:
				'https://chillhop.com/wp-content/uploads/2020/09/0255e8b8c74c90d4a27c594b3452b2daafae608d-1024x1024.jpg',
			artist: 'Aso, Middle School, Aviino',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=10075',
			color: ['#205950', '#2ab3bf'],
			id: uuidv4(),
			active: true,
		},
		{
			name: 'Daylight',
			cover:
				'https://chillhop.com/wp-content/uploads/2020/07/ef95e219a44869318b7806e9f0f794a1f9c451e4-1024x1024.jpg',
			artist: 'Aiguille',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=9272',
			color: ['#EF8EA9', '#ab417f'],
			id: uuidv4(),
			active: false,
		},
		{
			name: 'Keep Going',
			cover:
				'https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg',
			artist: 'Swørn',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=9222',
			color: ['#CD607D', '#c94043'],
			id: uuidv4(),
			active: false,
		},
		{
			name: 'Nightfall',
			cover:
				'https://chillhop.com/wp-content/uploads/2020/07/ef95e219a44869318b7806e9f0f794a1f9c451e4-1024x1024.jpg',
			artist: 'Aiguille',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=9148',
			color: ['#EF8EA9', '#ab417f'],
			id: uuidv4(),
			active: false,
		},
		{
			name: 'Reflection',
			cover:
				'https://chillhop.com/wp-content/uploads/2020/07/ff35dede32321a8aa0953809812941bcf8a6bd35-1024x1024.jpg',
			artist: 'Swørn',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=9228',
			color: ['#CD607D', '#c94043'],
			id: uuidv4(),
			active: false,
		},
		{
			name: 'Under the City Stars',
			cover:
				'https://chillhop.com/wp-content/uploads/2020/09/0255e8b8c74c90d4a27c594b3452b2daafae608d-1024x1024.jpg',
			artist: 'Aso, Middle School, Aviino',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=10074',
			color: ['#205950', '#2ab3bf'],
			id: uuidv4(),
			active: false,
		},
		//ADD MORE HERE
		{
			name: 'All in Good Spirit',
			cover:
				'https://chillhop.com/wp-content/uploads/2020/12/7e98d3028a22ee7f16f6a9bfcdc2089f089777a5-1024x1024.jpg',
			artist: 'Mama Auito',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=9261',
			color: ['#FCA670', '#355495'],
			id: uuidv4(),
			active: false,
		},
		{
			name: 'Hereafter',
			cover:
				'https://chillhop.com/wp-content/uploads/2020/11/f78c39b4bb6313ddd0354bef896c591bfb490ff8-1024x1024.jpg',
			artist: 'Makzo',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=11770',
			color: ['#13316C', '#E68778'],
			id: uuidv4(),
			active: false,
		},
		{
			name: 'Sleepy Fish',
			cover:
				'https://chillhop.com/wp-content/uploads/2020/11/8a0c857ddad531279d0757f5362380a6837b1b69-1024x1024.jpg',
			artist: 'Makzo',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=11251',
			color: ['#77965C', '#F2DD7F'],
			id: uuidv4(),
			active: false,
		},
		{
			name: 'Colors Fade',
			cover:
				'https://chillhop.com/wp-content/uploads/2020/09/686808356b2bbc6a368e372ea604150bc346c788-1024x1024.jpg',
			artist: 'Sleepy Fish',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=10023',
			color: ['#1E1C32', '#F6E4D5'],
			id: uuidv4(),
			active: false,
		},
		{
			name: 'Never Ending',
			cover:
				'https://chillhop.com/wp-content/uploads/2020/08/63d2d2cdabbc5df023603b5f47b2fb97963cb537-1024x1024.jpg',
			artist: 'Sitting Duck, sqeeda',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=9652',
			color: ['#527B73', '#F1CA53'],
			id: uuidv4(),
			active: false,
		},
	];
}

export default chillHop;
